import { useEffect, useRef, useState } from "react";

export const useBroadcastChannel = (channelName: string, onMessageHandler?: any) => {
  let isBroadcastSupported = useRef<any>(null);
  let channel = useRef<any>(null);

  useEffect(() => {
    // 브라우저가 Broadcast Channel API를 지원하는지 확인
    if ("BroadcastChannel" in window) {
      isBroadcastSupported.current = true;
    } else {
      isBroadcastSupported.current = false;
    }
  }, []);

  useEffect(() => {
    const handleStorage = (event: StorageEvent) => {
      if (event.key === `${channelName}`) {
        onMessageHandler({ data: JSON.parse(event.newValue) });
      }
    };
    if (!isBroadcastSupported) {
      window.addEventListener("storage", handleStorage);
    } else {
      channel.current = new BroadcastChannel(channelName);
    }
    return () => {
      window.removeEventListener("storage", handleStorage);
    };
  }, [isBroadcastSupported]);

  useEffect(() => {
    if (channel) {
      channel.current.onmessage = onMessageHandler;
    }
    return () => {
      if (channel) {
        channel.current.onmessage = null;
      }
    };
  }, [channel]);

  const broadcastMessage = (postMessage?: any) => {
    if (isBroadcastSupported.current === null || channel.current === null) {
    }
    if (isBroadcastSupported) {
      channel.current.postMessage(postMessage);
    } else {
      localStorage.setItem(`${channelName}`, `${JSON.stringify(postMessage)}`);
      // localStorage.setItem으로 메시지를 설정하면 storage 이벤트가 발생
      // 이후 바로 제거해 메시지 잔여 데이터를 남기지 않음
      setTimeout(() => {
        localStorage.removeItem(`${channelName}`);
      }, 0);
    }
  };

  return { broadcastMessage };
};
